angular.module('cvsApp').service('getOrderTrackingDetailsService',['networkService', 'xdrService', 'configManager', 'orderTrackingDetailsModel','cvsAppData', function (NS, XS,CM, OTDM,CAD) {

    function getOrderTrackingDetails (){
        this.getOrderTrackingDetails = function(callBackSuccess, shipmentNumber, numberOfShipment){
            //get url
            var tokenId= CAD.getTokenId();
            var tokenType= CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var url = CM.getApiUrlWithApikeyV2('GET_ORDER_TRACKING_DETAILS', tokenId, CAD.getTokenType());

            if(url === "URL_ERROR"){

            }else{

                //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                // if(shipmentNumber){
                //   url = url.replace('/getOrderTrackingDetails', '/getOrderTrackingDetails_'+shipmentNumber);
                // }
                // else {
                //     url = url.replace('/getOrderTrackingDetails', '/getOrderTrackingDetails_readytopickup');
                // }
                var request = {url:url,
                    header:{},
                    data:requestBody(shipmentNumber, numberOfShipment),
                    onSuccess:callBackSuccess
                }
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(url, "", xdrSuccess);

                    function xdrSuccess (data) {
                        OTDM.setResponse(data);
                        callBackSuccess(OTDM.getResponse());
                    }
                }
                else {
                    var promise = NS.post(request);
                    promise.then(function(data, c, d){

                        OTDM.setResponse(data.data);
                        callBackSuccess(OTDM.getResponse());

                    }, function(reason){
                        callBackSuccess(NS.httpError(reason));
                    });
                }
            }

        }


        var requestBody = function(shipmentNumber, numberOfShipment){
            var tokenId =  CAD.getTokenId();
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var requestDetails = {};
            if(shipmentNumber){
                requestDetails.shipmentNumber = shipmentNumber;
            }
            if(numberOfShipment){
                requestDetails.NumberOfShipment = numberOfShipment;
            }
            return {"getOrderTrackingDetailsRequest": {
                "header":    {
                    "serviceContext":       {
                        "appName": cvsUtility.queryMap.mobileAppStyle? 'SPL_APP' : 'SPL_WEB',
                        "lineOfBusiness": "Specialty",
                        "channelName": cvsUtility.queryMap.channel,
                        "tokenID": tokenId,
                        "tokenType": tokenType
                    },
                    "securityContext": {"apiKey": apikey}
                },
                "details": {"orderTracking":   requestDetails}
            }}



        }


        this.setResponse = function(data){
            PQM.setResponse(data);
        }

        this.getResponse = function(){
            return PQM.getResponse();
        }

    }

    return new getOrderTrackingDetails();
}]);
